import cryptoService from './cryptoService';

export async function validateSecureData(encryptedData) {
  try {
    if (!encryptedData.data || !encryptedData.iv || !encryptedData.key) {
      return false;
    }

    await cryptoService.decryptData(
      encryptedData.data,
      encryptedData.iv,
      encryptedData.key
    );
    return true;
  } catch {
    return false;
  }
}

export function clearInvalidData() {
  window.sessionStorage.clear();
  // Opcional: Emitir evento para notificar a aplicação
  window.dispatchEvent(new CustomEvent('secureStorage:invalid'));
}

// Opcional: Adicionar listeners globais
window.addEventListener('secureStorage:invalid', () => {
  window.location.href = '/login';
});
